import script from "./UserWallet.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserWallet.vue?vue&type=script&setup=true&lang=ts"

import "./UserWallet.vue?vue&type=style&index=0&id=3f557d6c&lang=scss"
import "./UserWallet.vue?vue&type=style&index=1&id=3f557d6c&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f557d6c"]])

export default __exports__